import React from "react";
import PanelLayout from "../components/PanelLayout";
import "./styles/PanelEditAd.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../redux/actions/adCategoryActions";
import { FaSave, FaArrowLeft } from "react-icons/fa";
import PanelEditGalery from "../components/PanelEditGalery";
import * as actions_publish from "../redux/actions/publishActions";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

import CKEditor from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import { Translate, I18n } from "react-redux-i18n";
import MiniLoader from "../components/MiniLoader";
import { ListSkeleton } from "../components/Skeleton";
import PanelAddLinkYoutube from "../components/PanelAddLinkYoutube";
import moment from "moment";
import * as actions_ad from "../redux/actions/adActions";

const PANEL_EDIT_GODER_ID_KEY = "panelEditGoderId";

const KIND_LABEL_KEYS = {
  sale: "ad_sale",
  rent: "ad_rent",
  exchange: "ad_exchange",
  donation: "ad_donation",
  auction: "auction",
};

const KIND_BACK_ROUTES = {
  sale: "/panel/ads",
  rent: "/panel/ads",
  exchange: "/panel/ads",
  donation: "/panel/ads",
  auction: "/panel/ads",
};

function FormField({ label, required, children, width = "full" }) {
  const widthClass =
    width === "third"
      ? "panel-edit-ad-field--third"
      : width === "half"
        ? "panel-edit-ad-field--half"
        : "";

  return (
    <div className={`panel-edit-ad-field ${widthClass}`}>
      <label className="panel-edit-ad-label">
        {required && <span className="panel-edit-ad-required">*</span>}
        {label}
      </label>
      {children}
    </div>
  );
}

class AdCategoryItem extends React.Component {
  render() {
    return <option value={this.props.item.key}>{this.props.item.label}</option>;
  }
}

class PanelEditAd extends React.Component {
  state = {
    form: {
      price: "1.0",
      name: "",
      description: "",
      category_id: "0",
      condition: "NEW",
      frequency: "H",
      request: "",
      store_id: "",
      quantity: "",
      expiration: "",
    },
    kindComerce: "",
  };

  componentDidMount() {
    this.setState({ kindComerce: this.props.match.params.kindCommerce_id });
    this.fetchAdCategoryList();

    const storedId =
      sessionStorage.getItem(PANEL_EDIT_GODER_ID_KEY) ||
      (this.props.ad?.Id ? String(this.props.ad.Id) : "");

    if (storedId) {
      sessionStorage.setItem(PANEL_EDIT_GODER_ID_KEY, storedId);
      this.ensureAdLoaded(storedId);
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.ad?.Id) {
      return;
    }

    const adChanged = this.props.ad.Id !== prevProps.ad?.Id;
    const adJustLoaded = prevProps.loadingAd && !this.props.loadingAd;
    const expirationChanged =
      (prevProps.ad?.ExpirationDate || "") !== (this.props.ad?.ExpirationDate || "");

    if (adChanged || adJustLoaded || expirationChanged) {
      sessionStorage.setItem(PANEL_EDIT_GODER_ID_KEY, String(this.props.ad.Id));
      this.syncFormFromAd(this.props.ad);
    }
  }

  ensureAdLoaded = async (goderId) => {
    const adId = goderId || sessionStorage.getItem(PANEL_EDIT_GODER_ID_KEY);
    if (!adId) return;

    try {
      await this.props.LoadAd(this.props.token, {
        goder_id: adId,
        id: this.props.user_id,
        lang: I18n.t("locale"),
      });

      if (this.props.adError) {
        alertify.warning(I18n.t(this.props.adError));
      }
    } catch (error) {
      console.log(error);
    }
  };

  syncFormFromAd = (ad) => {
    if (!ad?.Id) return;

    const expirationDate =
      ad.ExpirationDate && moment(ad.ExpirationDate).isValid()
        ? moment(ad.ExpirationDate).format("YYYY-MM-DD")
        : "";

    this.setState({
      form: {
        name: ad.Name || "",
        quantity: ad.Quantity || "",
        price: ad.Price || "1.0",
        frequency: ad.Frequency?.Id || "H",
        condition: ad.Condition?.Id || "NEW",
        category_id: ad.Category?.Id || "0",
        store_id: ad.Store?.Id || "",
        description: ad.Description || "",
        expiration: expirationDate,
        request: ad.Request || "",
      },
    });
  };

  fetchAdCategoryList = async () => {
    try {
      await this.props
        .LoadCategories(this.props.user_id, this.props.token)
        .then(() => {
          if (this.props.error) {
            alert(this.props.error);
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  handleChange = (e) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeDescription = (evt, editor) => {
    this.setState({
      form: {
        ...this.state.form,
        description: editor.getData(),
      },
    });
  };

  onClickSave = async () => {
    if (!this.props.ad?.Id) {
      alertify.warning(I18n.t("try_later"));
      return;
    }

    if (
      this.state.kindComerce === "auction" &&
      !this.state.form.expiration
    ) {
      alertify.warning(I18n.t("expire"));
      return;
    }

    var KindCommerceId = "0";
    switch (this.state.kindComerce) {
      case "donation":
        KindCommerceId = "1";
        break;

      case "sale":
        KindCommerceId = "2";
        break;

      case "exchange":
        KindCommerceId = "3";
        break;

      case "rent":
        KindCommerceId = "4";
        break;

      case "auction":
        KindCommerceId = "5";
        break;

      default:
        KindCommerceId = "2";
        break;
    }
    const params = {
      goder_id: this.props.ad.Id,
      name: this.state.form.name,
      quantity: this.state.form.quantity || "0",
      price: this.state.form.price || "1",
      description: this.state.form.description,
      category_id: this.state.form.category_id,
      kindcommerce_id: KindCommerceId,
      condition_id: this.state.form.condition || "",
      frequency_id: this.state.form.frequency || "",
      numRequest: this.state.form.request || "0",
      store_id: this.state.form.store_id || "",
      expiration: this.state.form.expiration || "",
      id: this.props.user_id,
      lang: I18n.t("locale"),
    };

    try {
      const onSaved = (result) => {
        if (!result?.success) {
          alertify.warning(I18n.t(result?.error || "try_later"));
          return;
        }

        alertify.success(I18n.t("saved_succesfull"));

        if (result.item?.Id) {
          this.syncFormFromAd(result.item);
          this.props.SetAd(result.item);
        }
      };

      if (KindCommerceId === "1")
        onSaved(await this.props.AdNewDonation(this.props.token, params));
      else if (KindCommerceId === "2")
        onSaved(await this.props.AdNewSales(this.props.token, params));
      else if (KindCommerceId === "3")
        onSaved(await this.props.AdNewExchange(this.props.token, params));
      else if (KindCommerceId === "4")
        onSaved(await this.props.AdNewRent(this.props.token, params));
      else if (KindCommerceId === "5")
        onSaved(await this.props.AdNewAuction(this.props.token, params));
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const texto = this.state.form.description;
    const kind = this.state.kindComerce;
    const kindLabelKey = KIND_LABEL_KEYS[kind] || "ad_sale";
    const backRoute = KIND_BACK_ROUTES[kind] || "/panel/ads";
    const ad = this.props.ad;
    const hasAd = Boolean(ad?.Id);
    const storedAdId = sessionStorage.getItem(PANEL_EDIT_GODER_ID_KEY);
    const isLoadingAd = !hasAd && Boolean(storedAdId) && this.props.loadingAd;

    if (isLoadingAd) {
      return (
        <PanelLayout>
          <div className="panel-edit-ad-page">
            <ListSkeleton />
          </div>
        </PanelLayout>
      );
    }

    if (!hasAd) {
      return (
        <PanelLayout>
          <div className="panel-edit-ad-page">
            <header className="panel-edit-ad-page__header">
              <Link to={backRoute} className="panel-edit-ad-page__back" aria-label="Back">
                <FaArrowLeft />
              </Link>
              <div className="panel-edit-ad-page__heading">
                <h1 className="panel-edit-ad-page__title">
                  <Translate value="ad_edit" />
                </h1>
              </div>
            </header>
            <div className="panel-edit-ad-card panel-edit-ad-card--empty">
              <p>
                <Translate value="try_later" />
              </p>
              <Link to={backRoute} className="panel-edit-ad-page__save">
                <FaArrowLeft />
                <Translate value="back" />
              </Link>
            </div>
          </div>
        </PanelLayout>
      );
    }

    const store = ad.Store || {};

    return (
      <PanelLayout>
        <div className="panel-edit-ad-page">
          <header className="panel-edit-ad-page__header">
            <Link to={backRoute} className="panel-edit-ad-page__back" aria-label="Back">
              <FaArrowLeft />
            </Link>
            <div className="panel-edit-ad-page__heading">
              <h1 className="panel-edit-ad-page__title">
                <Translate value="ad_edit" />
              </h1>
              <p className="panel-edit-ad-page__subtitle">{I18n.t(kindLabelKey)}</p>
            </div>
          </header>

          <section className="panel-edit-ad-card">
            <h2 className="panel-edit-ad-card__title">
              <Translate value="ad_new_title" />
            </h2>

            <div className="panel-edit-ad-form__grid">
              <FormField
                label={<Translate value="ad_name" />}
                required
              >
                <input
                  type="text"
                  id="name"
                  name="name"
                  data-type="product_detail"
                  required
                  maxLength="100"
                  className="panel-edit-ad-input"
                  onChange={this.handleChange}
                  value={this.state.form.name}
                />
              </FormField>

              <FormField
                label={<Translate value="ad_quantity" />}
                required
                width="third"
              >
                <div className="panel-edit-ad-input-group">
                  <span className="panel-edit-ad-input-group__prefix">#</span>
                  <input
                    type="number"
                    min="0"
                    id="quantity"
                    data-type="product"
                    name="quantity"
                    className="panel-edit-ad-input"
                    value={this.state.form.quantity}
                    onChange={this.handleChange}
                  />
                </div>
              </FormField>

              <FormField
                label={<Translate value="ad_price" />}
                required
                width="third"
              >
                <div className="panel-edit-ad-input-group">
                  <span className="panel-edit-ad-input-group__prefix">$</span>
                  <input
                    type="number"
                    step="0.01"
                    required
                    min="0"
                    id="price"
                    data-type="product"
                    name="price"
                    className="panel-edit-ad-input"
                    value={this.state.form.price}
                    onChange={this.handleChange}
                  />
                </div>
              </FormField>

              {kind === "auction" && (
                <FormField
                  label={
                    <>
                      <Translate value="expire" />
                      <small>{" 3 month max"}</small>
                    </>
                  }
                  required
                  width="third"
                >
                  <input
                    type="date"
                    required
                    id="expiration"
                    min={moment().format("YYYY-MM-DD")}
                    max={moment().add(3, "M").format("YYYY-MM-DD")}
                    data-date-format="YYYY-MM-DD"
                    name="expiration"
                    className="panel-edit-ad-input"
                    value={this.state.form.expiration}
                    onChange={this.handleChange}
                  />
                </FormField>
              )}

              {kind === "rent" ? (
                <FormField
                  label={<Translate value="ad_frecuency" />}
                  width="third"
                >
                  <select
                    className="panel-edit-ad-select"
                    data-type="product"
                    name="frequency"
                    value={this.state.form.frequency}
                    onChange={this.handleChange}
                  >
                    <option value="H">{I18n.t("ad_hour")}</option>
                    <option value="D">{I18n.t("ad_day")}</option>
                    <option value="M">{I18n.t("ad_month")}</option>
                    <option value="Y">{I18n.t("ad_year")}</option>
                  </select>
                </FormField>
              ) : (
                kind !== "auction" && (
                  <FormField
                    label={<Translate value="ad_condition" />}
                    width="third"
                  >
                    <select
                      className="panel-edit-ad-select"
                      data-type="product"
                      name="condition"
                      value={this.state.form.condition}
                      onChange={this.handleChange}
                    >
                      <option value="NEW">{I18n.t("ad_new")}</option>
                      <option value="USED">{I18n.t("ad_used")}</option>
                      <option value="SERVICE">{I18n.t("ad_service")}</option>
                    </select>
                  </FormField>
                )
              )}

              <FormField
                label={<Translate value="ad_category" />}
                width="half"
              >
                <select
                  className="panel-edit-ad-select"
                  required
                  data-type="category"
                  name="category_id"
                  value={this.state.form.category_id}
                  onChange={this.handleChange}
                >
                  <option value={0}>{I18n.t("ad_category_select")}</option>
                  {this.props.adCategoryList.map((item) => (
                    <AdCategoryItem item={item} key={item.key} />
                  ))}
                </select>
              </FormField>

              {kind === "donation" ? (
                <FormField
                  label={<Translate value="ad_request" />}
                  required
                  width="half"
                >
                  <div className="panel-edit-ad-input-group">
                    <span className="panel-edit-ad-input-group__prefix">#</span>
                    <input
                      type="number"
                      min="0"
                      id="request"
                      data-type="product"
                      name="request"
                      className="panel-edit-ad-input"
                      value={this.state.form.request}
                      onChange={this.handleChange}
                    />
                  </div>
                </FormField>
              ) : (
                <FormField
                  label={<Translate value="ad_marketstore" />}
                  width="half"
                >
                  <select
                    className="panel-edit-ad-select"
                    data-type="product"
                    name="store_id"
                    value={this.state.form.store_id}
                    onChange={this.handleChange}
                  >
                    {store.Id ? (
                      <option value={store.Id}>
                        {store.Name}
                      </option>
                    ) : (
                      <option value="0">{I18n.t("ad_not_marketstore")}</option>
                    )}
                  </select>
                </FormField>
              )}

              <FormField label={<Translate value="ad_description" />}>
                <div className="panel-edit-ad-editor">
                  <CKEditor
                    data={texto == null ? "" : texto}
                    editor={ClassicEditor}
                    onChange={(e, editor) =>
                      this.handleChangeDescription(e, editor)
                    }
                    name="description"
                    onInit={(editor) => {
                      editor.setData(texto);
                    }}
                  />
                </div>
              </FormField>
            </div>
          </section>

          <PanelEditGalery />

          {this.props.loadingMedia ? <MiniLoader /> : <PanelAddLinkYoutube />}

          <footer className="panel-edit-ad-page__actions">
            <button
              type="button"
              className="panel-edit-ad-page__save"
              onClick={this.onClickSave}
            >
              <FaSave />
              {I18n.t("save")}
            </button>
          </footer>
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.ad.item,
    loadingAd: reducer.ad.loading,
    adError: reducer.ad.error,

    adCategoryList: reducer.adCategory.list,
    error: reducer.adCategory.error,
    loading: reducer.adCategory.loading,

    error_update: reducer.publish.error_update,
    updatedAd: reducer.publish.item,

    loadingMedia: reducer.media.loading,
  };
}
const mapDispatchToProps = (dispatch) => ({
  LoadCategories: (user_id, token) =>
    dispatch(actions.loadList({ user_id, token })),
  LoadAd: (token, params) =>
    dispatch(actions_ad.loadItem({ token, params })),
  AdNewSales: (token, params) => dispatch(actions_publish.updateItem({ token, params })),
  AdNewRent: (token, params) => dispatch(actions_publish.updateItem({ token, params })),
  AdNewExchange: (token, params) => dispatch(actions_publish.updateItem({ token, params })),
  AdNewDonation: (token, params) => dispatch(actions_publish.updateItem({ token, params })),
  AdNewAuction: (token, params) => dispatch(actions_publish.updateItem({ token, params })),
  SetAd: (item) => dispatch(actions_ad.setAd({ item })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelEditAd);
